export default "__VITE_PUBLIC_ASSET__b72c6bcf__"